import React from "react";
import { createConsumer } from "@rails/actioncable";
import PropTypes from "prop-types";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import Switch from "react-switch";
import ReportCardLevel from "./ReportCardLevel.js";

const BackLinkGroupLesson = props => {
  const { groupLesson } = props;
  return (
    <a
      href={"/group_lessons/" + groupLesson.id}
      className="styled-link"
    >
      Back to Lesson
    </a>
  )
}

const BackLinkMember = props => {
  const { member } = props;

  return (
    <a
      href={"/members/" + member.id}
      className="styled-link"
    >
      Back to Member
    </a>
  )
}

const GroupLessonHeader = props => {
  const { groupLesson } = props;

  return (
    <div>
      <h2 className="h1-h2-stacked center-text">
        {"Level for this Lesson: " + groupLesson.group_lesson_level.name}
      </h2>
      <h2 className="date-h2 center-text">
        {groupLesson.session_schedule}
      </h2>
    </div>
  )
}

const MemberList = props => {
  const { reportCards } = props;
  const { selectedReportCard } = props;
  const { selectedReportCardLevel } = props;

  return (
    <div>
      {reportCards.map((reportCard) =>
        <MemberReportCard
          reportCard={reportCard}
          selectedReportCard={selectedReportCard}
          selectedReportCardLevel={selectedReportCardLevel}
          key={reportCard.id}
          selectReportCardLevel={props.selectReportCardLevel}
        />
      )}
      {props.groupLesson ? (
        <BackLinkGroupLesson groupLesson={props.groupLesson} />
      ) : (
        <BackLinkMember member={_.first(reportCards).member} />
      )}
    </div>
  )
}

const MemberReportCard = props => {
  const { reportCard } = props;
  const { selectedReportCard } = props;
  const { selectedReportCardLevel } = props;

  return (
    <ul className="shadowDepth1 list-group">
      <li
        className={
          "list-group-item pointer-hand" +
          ((reportCard.id == selectedReportCard.id) ? " active" : "")
        }
      >
        <span className="margin-right-five">
          {reportCard.member.first_name + " " + reportCard.member.last_name}
        </span>
      </li>

      {reportCard.active_report_card_levels.map((reportCardLevel) =>
        <MemberReportCardLevel
          reportCard={reportCard}
          reportCardLevel={reportCardLevel}
          selectedReportCardLevel={selectedReportCardLevel}
          key={reportCardLevel.id}
          selectReportCardLevel={props.selectReportCardLevel}
        />
      )}
    </ul>
  )
}

const MemberReportCardLevel = props => {
  const { reportCard } = props;
  const { reportCardLevel } = props;
  const { selectedReportCardLevel } = props;
  const archivedLevel = (reportCardLevel.sort_order == 99);
  const latestAtThisLevel = reportCardLevel.latest_at_this_level;
  const showHelpTooltip = (archivedLevel || !latestAtThisLevel);
  var createdAtToolTip = "Sent: never";

  if (reportCardLevel.sent) {
    createdAtToolTip =
      "Sent: " +
      moment(reportCardLevel.sent_at).format("dddd, MMMM Do YYYY, h:mm:ss A");
  }

  return (
    <li
      className={
        "list-group-item pointer-hand" +
        (reportCardLevel.id == selectedReportCardLevel.id ? " active" : "")
      }
      onClick={e => props.selectReportCardLevel(reportCard, reportCardLevel)}
      data-tip={showHelpTooltip ? "" : null}
      data-for={"reportCardLevelTooltip-" + reportCardLevel.id}
    >
      <span className="margin-left-ten margin-right-five">
        {reportCardLevel.name}
      </span>

      {reportCardLevel.sent ? (
        <span data-tip={createdAtToolTip}>
          <i className="material-icons indigo500 icon-for-nav">email</i>
          <ReactTooltip />
        </span>
      ) : (
        <i className="material-icons grey-base icon-for-nav">email</i>
      )}

      {showHelpTooltip ? (
        <i className="material-icons red300 icon-for-nav pull-right">help</i>
      ) : (
        ""
      )}

      <ReactTooltip id={"reportCardLevelTooltip-" + reportCardLevel.id} place="top" type="info" effect="solid">
        {archivedLevel ? (
          <div>
            <h4>Archived Level</h4>
            <span>The Level for this Report Card has been removed from the main Program.</span>
          </div>
        ) : (
          <div>
            <h4>Repeated Level</h4>
            <span>This is a Report Card for a repeated level.  This level was taken in the Lesson(s):</span>
            {reportCardLevel.group_lessons &&
              <div>
                {reportCardLevel.group_lessons.slice(0, 5).map((groupLesson, index) =>
                  <div key={reportCardLevel.id + "-" + groupLesson.id + "-" + index}>- {groupLesson.session_schedule})</div>
                )}
              </div>
            }
          </div>
        )}
      </ReactTooltip>
    </li>
  )
}

class ReportCards extends React.Component {
  state = {
    reportCards: this.props.reportCards,
    selectedReportCard: _.first(this.props.reportCards),
    selectedReportCardLevel: {},
    groupLessonPrograms: this.props.groupLessonPrograms,
    subscriptions: {}
  };

  selectReportCardLevel = (reportCard, reportCardLevel) => {
    this.setState({
      selectedReportCard: reportCard,
      selectedReportCardLevel: reportCardLevel,
    });
  };

  componentWillMount () {
    this.setInitialSelectedReportCardLevel();
    this.subscribeToReportCardChannel()
  }

  componentWillUnmount () {
    this.unsubscribe();
  }

  setInitialSelectedReportCardLevel = () => {
    var selectedReportCardLevel = {};
    if (this.props.groupLesson) {
      selectedReportCardLevel = _.first(this.state.reportCards).active_report_card_levels.find(
        (reportCardLevel) => (reportCardLevel.group_lesson_level_id == this.props.groupLesson.group_lesson_level_id) &&
        (reportCardLevel.latest_at_this_level == 1)
      );

      if (!selectedReportCardLevel) {
        selectedReportCardLevel = _.first(this.state.selectedReportCard.active_report_card_levels);
      }
    } else {
      selectedReportCardLevel = _.first(this.state.selectedReportCard.active_report_card_levels);
    }

    this.setState({
      selectedReportCardLevel: selectedReportCardLevel
    });
  }

  subscribeToReportCardChannel = () => {
    this.connection = createConsumer('/cable')
    const subscriptions = _.map(this.state.reportCards, (reportCard) => {
      if (this.state.subscriptions[reportCard.id]) {
        return this.state.subscriptions[reportCard.id];
      }

      const subscription = this.connection.subscriptions.create({
        channel: 'ReportCardChannel',
        report_card_id: reportCard.id
      }, {
        connected: () => {},
        disconnected: () => {},
        received: (reportCardData) => {
          if(Application.currentUser.id === reportCardData.updatedByUserId) return;

          const updatedReportCard = reportCardData.report_card
          let reportCards = this.state.reportCards
          let reportCardIndex = _.findIndex(reportCards, { id: updatedReportCard.id })
          reportCards[reportCardIndex] = updatedReportCard

          if (this.state.selectedReportCardLevel.id === reportCardData.reportCardLevelId) {
            let reportCardLevelIndex = _.findIndex(updatedReportCard.active_report_card_levels, { id: reportCardData.reportCardLevelId })
            let updatedReportCardLevel = updatedReportCard.active_report_card_levels[reportCardLevelIndex]
            const reportCardLanguage = reportCardData.report_card.group_lesson_program.report_card_language

            this.setState({ reportCards: reportCards, selectedReportCardLevel: updatedReportCardLevel });
            toastr.info(`${reportCardLanguage} updated by ${reportCardData.updatedBy}`);
          } else {
            this.setState({ reportCards: reportCards });
          }
        }
      })

      return subscription
    })

    this.setState({subscriptions})
  }

  unsubscribe = () => {
    _.each(this.state.subscriptions, (subscription) => {
      if (!subscription) return;

      subscription.unsubscribe();
    })
  }

  updateReportCardLevel = (updatedReportCardLevel) => {
    var reportCards = this.state.reportCards;
    var indexReportCard = _.findIndex(reportCards, {
      id: updatedReportCardLevel.report_card_id
    });
    reportCards[indexReportCard].active_report_card_levels = reportCards[indexReportCard].active_report_card_levels.map(
      reportCardLevel => reportCardLevel.id === updatedReportCardLevel.id ? updatedReportCardLevel : reportCardLevel
    )
    this.setState({ reportCards: reportCards });
  }

  setNextLevel = (next_level)=>{
    let selectedReportCardLevel = this.state.selectedReportCardLevel;
    selectedReportCardLevel.next_level = next_level;
    this.setState({selectedReportCardLevel : selectedReportCardLevel})
  }

  getPdfUrl = () => {
    const selectedGroupLessonProgram = _.find(
      this.state.groupLessonPrograms,
      (groupLessonProgram) => groupLessonProgram.id == this.state.selectedReportCard.group_lesson_program_id
    );
    let url;

    if(selectedGroupLessonProgram.email_pdf_complete_report_card) {
      url = `/report_cards/${this.state.selectedReportCard.id}.pdf/`;
    } else {
      url = `/report_card_levels/${this.state.selectedReportCardLevel.id}.pdf`;
    }

    if(this.props.groupLesson)
      url += `?group_lesson_id=${this.props.groupLesson.id}`;

    return url;
  }

  render() {
    return (
      <div>
        <h1 className="h1-h2-stacked">
          {this.state.selectedReportCard.name}
        </h1>
        {this.props.groupLesson &&
          <GroupLessonHeader groupLesson={this.props.groupLesson} />
        }
        <br className="visible-xs" />
        <br className="visible-xs" />
        <div className="row">
          <div className="col-md-3">
            <h4 className="center-text">Members</h4>
              <MemberList
                reportCards={this.state.reportCards}
                selectedReportCard={this.state.selectedReportCard}
                selectedReportCardLevel={this.state.selectedReportCardLevel}
                groupLesson={this.props.groupLesson}
                selectReportCardLevel={this.selectReportCardLevel}
                selectChooseLevel={this.selectChooseLevel}
              />
          </div>
          <div className="col-md-9">
            <div className='report-card-level-header'>
              <h4 className="center-text title">
                {this.state.selectedReportCard.group_lesson_program.report_card_language}:
                {" " + this.state.selectedReportCard.member.first_name + " "}
                {this.state.selectedReportCard.member.last_name} -
                {" " + this.state.selectedReportCardLevel.name}
              </h4>
              <a
                key="pdf"
                href={this.getPdfUrl()}
                target="_blank"
                className="btn btn-indigo btn-raised btn-long margin-right-five"
              >
                PDF
              </a>
            </div>
            <div className="well shadowDepth1">
              <ReportCardLevel
                reportCard={this.state.selectedReportCard}
                reportCardLevel={this.state.selectedReportCardLevel}
                useSafetySwimSkills={this.state.selectedReportCard.group_lesson_program.use_safety_swim_skills}
                failedString={this.state.selectedReportCard.group_lesson_program.failed_string}
                passedString={this.state.selectedReportCard.group_lesson_program.passed_string}
                reportCardLanguage={this.state.selectedReportCard.group_lesson_program.report_card_language}
                emailPdfCompleteReportCard = {this.state.selectedReportCard.group_lesson_program.email_pdf_complete_report_card}
                groupLesson={this.props.groupLesson}
                updateReportCardLevel={this.updateReportCardLevel}
                setNextLevel={this.setNextLevel}
                groupLessonPrograms={this.state.groupLessonPrograms}
                reportCards={this.state.reportCards}
                next_level={this.state.selectedReportCardLevel.next_level}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ReportCards.propTypes = {
  groupLesson: PropTypes.object,
  reportCards: PropTypes.array,
  currentUser: PropTypes.object,
  selectedReportCard: PropTypes.object,
  selectedReportCardLevel: PropTypes.object,
  groupLessonPrograms: PropTypes.object
};

export default ReportCards;
